export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/external-link-73626c956d8c8aaba7a9e1aa162f3228.svg";